module.exports = __webpack_public_path__ + "static/media/dumpTruck_salmon.c1657b09.svg";